var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('LeftSidebar'),_c('div',{staticClass:"main-content"},[_c('nav-bar',{attrs:{"page_name":"Apps"}}),_c('div',{staticClass:"container-fluid w-100 d-flex flex-column main-content-sub-container"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }